import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    marginTop: 16
  },
  top: { padding: theme.spacing(2) },
  bottom: { padding: theme.spacing(2) },
  table: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    overflow: 'hidden'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    alignItems: 'center',
    padding: '8px 0px'
  },
  headerRow: {
    backgroundColor: theme.palette.grey[200],
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    justifyContent: 'center',
    alignItems: 'center',
    height: 27
  },
  cell: {
    flex: 1,
    textAlign: 'center',
    fontWeight: 600,
    color: theme.palette.grey[600]
  },
  statusDone: {
    color: theme.palette.secondary.main
  },
  retryLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  blackText: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 8
  },
  doneButton: {
    marginRight: 8
  }
}))
